import { useAuthStore } from '@/stores/authStore'

/**
 * Whether the current user holds a permission.
 *
 * This drives *visibility only*. The backend re-checks every call with `@PreAuthorize`,
 * so hiding a button is a usability nicety, never the security boundary.
 */
export function usePermission(permission?: string): boolean {
  return useAuthStore((state) => {
    if (!permission) return true
    if (state.user?.roles.includes('SUPER_ADMIN')) return true
    return state.permissions.has(permission)
  })
}

/** True when the user holds every listed permission. */
export function useAllPermissions(permissions: string[]): boolean {
  return useAuthStore((state) => {
    if (state.user?.roles.includes('SUPER_ADMIN')) return true
    return permissions.every((permission) => state.permissions.has(permission))
  })
}

/** True when the user holds at least one of the listed permissions. */
export function useAnyPermission(permissions: string[]): boolean {
  return useAuthStore((state) => {
    if (state.user?.roles.includes('SUPER_ADMIN')) return true
    return permissions.some((permission) => state.permissions.has(permission))
  })
}

export function useCurrentUser() {
  return useAuthStore((state) => state.user)
}
